export const config = {
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN!,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
  },
  stack: process.env.REACT_APP_STACK! || 'dev', // Default to 'dev' if not set
};